import { render } from "./BookLook.vue?vue&type=template&id=2a98d652&scoped=true"
import script from "./BookLook.vue?vue&type=script&lang=js"
export * from "./BookLook.vue?vue&type=script&lang=js"

import "./BookLook.vue?vue&type=style&index=0&id=2a98d652&lang=scss&scoped=true"
import "./BookLook.vue?vue&type=style&index=1&id=2a98d652&lang=css"

import exportComponent from "D:\\web\\journal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a98d652"]])

export default __exports__